  import React from 'react';
  import { useNavigate } from 'react-router-dom';
  import { useRbac } from '../../context';
  import { MultiStepForm } from '../../components/ui/MultiStepForm';

  const RecruiterOnboarding = () => {
    const { user } = useRbac();
    const navigate = useNavigate();

    const handleOnboardingComplete = () => {
      // Save completion status
      localStorage.setItem(`onboarding_completed_${user.id}`, 'true');
      // Redirect to dashboard
      navigate('/dashboard');
    };
    
    return (
      <div className="min-h-screen bg-gray-50 w-full">
        {/* Onboarding Header */}
        <div className="bg-white shadow-sm border-b w-full">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center py-6">
              <div className="flex items-center">
                <h1 className="text-3xl font-bold text-gray-900">
                  Welcome to EarlyJobs
                </h1>
              </div>
              <div className="text-sm text-gray-500 text-right">
                <p className="font-medium">Complete your profile to get started</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Onboarding Content */}
        <div className="py-8 w-full">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-8 text-center">
              <p className="text-md text-gray-600 m">
                Please fill out the following information to complete your registration and start using the platform.
              </p>
            </div>
            
            <MultiStepForm onFormSubmit={handleOnboardingComplete} isCompact={false} />
          </div>
        </div>
      </div>
    );
  };

  export default RecruiterOnboarding;
